var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{staticClass:"schedule-event",style:(_vm.style),attrs:{"dark":!_vm.darkMode,"color":"info","dense":""},on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.title)}})])}
var staticRenderFns = []

export { render, staticRenderFns }